var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container", staticClass: "day-grid-month" },
    [
      _c(
        "div",
        { staticClass: "days-labels" },
        _vm._l(_vm.dayLabels, function (day) {
          return _c("div", { key: day, staticClass: "day-label" }, [
            _vm._v("\n            " + _vm._s(day) + "\n        "),
          ])
        }),
        0
      ),
      _c(
        "div",
        { staticClass: "days-cells" },
        _vm._l(_vm.daysInGrid, function (day, cellIndex) {
          return _c(
            "div",
            {
              key: cellIndex,
              ref: "cellRefs",
              refInFor: true,
              staticClass: "day-cell",
              class: {
                past: day.isPast,
                "current-month": day.isCurrentMonth,
                "not-current-month": !day.isCurrentMonth,
                today: day.isToday,
                "has-events":
                  _vm.getEventsForCell(day.dateKey).length > 0 ||
                  (_vm.eventsByDate[day.dateKey] &&
                    _vm.eventsByDate[day.dateKey].length >
                      _vm.maxVisibleEvents),
              },
              attrs: { "data-drag-event-location": day.dateString },
              on: { click: (e) => _vm.selectDate(e, day.dateKey) },
            },
            [
              _c("div", { staticClass: "header-cell" }, [
                _c("div", { staticClass: "date-number" }, [
                  _vm._v(_vm._s(day.dayNumber)),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "events" },
                [
                  _vm._l(_vm.getEventsForCell(day.dateKey), function (event) {
                    return _c(
                      "Event",
                      _vm._b(
                        {
                          key: event.id,
                          attrs: {
                            isPlaceholder:
                              _vm.eventDragged.eventId === event.id,
                            isDraggable: event.editable !== false,
                          },
                          on: {
                            eventDragStart: _vm.eventDragStart,
                            eventClick: function ($event) {
                              return _vm.$emit("eventClick", event.id)
                            },
                          },
                        },
                        "Event",
                        event,
                        false
                      )
                    )
                  }),
                  _vm.eventsByDate[day.dateKey] &&
                  _vm.eventsByDate[day.dateKey].length > _vm.maxVisibleEvents
                    ? _c(
                        "div",
                        {
                          staticClass: "btn-more",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.showMoreEvents(day.dateKey, cellIndex)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t("dash.posts.planner.more-events", {
                                  count:
                                    _vm.eventsByDate[day.dateKey].length -
                                    _vm.maxVisibleEventsWithBtn,
                                })
                              ) +
                              "\n                "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                2
              ),
            ]
          )
        }),
        0
      ),
      _vm.popUpOptions.cellKey
        ? _c("EventsPopUp", {
            attrs: {
              eventDragged: _vm.eventDragged,
              events: _vm.eventsByDate[_vm.popUpOptions.cellKey],
              containerRef: _vm.$refs.container,
              anchorRef: _vm.popUpOptions.anchorRef,
              title: _vm.popUpOptions.dateLabel,
            },
            on: {
              close: _vm.closeMoreEvents,
              eventDragStart: _vm.eventDragStart,
              eventClick: (id) => _vm.$emit("eventClick", id),
            },
          })
        : _vm._e(),
      _c(
        "DraggableEvent",
        _vm._b(
          { on: { eventDragStop: _vm.eventDragStop } },
          "DraggableEvent",
          _vm.eventDragged,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }